<template>
  <div id="main-role">
    <el-table
      :data="roles"
      style="width: 90%">
      <el-table-column
        prop="roleId"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="roleChName"
        label="角色名">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作">
        <template slot-scope="scope">
            <el-button
            @click.native.prevent="showPerDialog(scope.row)"
            type="text"
            size="mini">
                权限
            </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        title="分配权限"
        :visible.sync="permissionDialogShow"
        width="30%">
        <el-tree
            :data="role.rolePermissions"
            show-checkbox
            node-key="id"
            :props= "permissionTreeProps"
             @check-change="handleCheckChange"
            :default-checked-keys="role.rolePermissionIds">
        </el-tree>
        <span slot="footer" class="dialog-footer">
            <el-button @click="permissionDialogShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmRolePermission">确 定</el-button>
        </span> 
    </el-dialog>
  </div>
</template>

<script>

import { queryAll,queryAllPermissionRole,updateRolePermissions } from "@/api/role.js"

export default {
  name: 'Role',
  data() {
    return {
      roles: [],
      role: {
        roleId: null,
        rolePermissions: [],
        rolePermissionIds: [],
        rolePermissionSet: new Set(),
      },
      permissionDialogShow: false,
      permissionTreeProps: {label: 'desc'}
    }
  },
  watch: {
    
  },
  created() {
  },
  mounted() {
    queryAll().then(data=>{
        this.roles = data.data
    })
  },
  destroyed() {
    
  },
  methods: {
    showPerDialog(role){
        this.permissionDialogShow=true
        this.role.roleId = role.roleId
        this.role.rolePermissionSet = new Set()
        queryAllPermissionRole(role.roleId).then(data=>{
            this.role.rolePermissions = data.data
            this.role.rolePermissions.forEach(rp=>{
                if(role.roleId!=rp.roleId){
                    return
                }
                this.role.rolePermissionSet.add(rp.id)
            })
            this.role.rolePermissionIds = [...this.role.rolePermissionSet]
        })
    },
    handleCheckChange(data, checked) {
        if(checked){
            this.role.rolePermissionSet.add(data.id)
        }else{
            this.role.rolePermissionSet.delete(data.id)
        }
    },
    confirmRolePermission(){
        let permissionIds = [...this.role.rolePermissionSet]
        let role = {roleId: this.role.roleId, permissionIds: permissionIds.join(",")}
        updateRolePermissions(role).then(()=>{
            this.permissionDialogShow = false
        })
    }
  }
}
</script>

<style>

</style>
